import Vue from "vue";
import VueTailwind from "vue-tailwind";

import {
  TInput,
  TTextarea,
  TButton,
  TModal,
  TCard,
  TTable,
  TCheckbox,
  TPagination,
  TRadio,
  TDatepicker,
  TSelect,
  TRichSelect,
} from "vue-tailwind/dist/components";

const components = {
  TInput,
  TTextarea,
  TButton,
  TModal,
  TCard,
  TCheckbox,
  TTable,
  TPagination,
  TRadio,
  TDatepicker,
  TSelect,
  TRichSelect,
};

Vue.use(VueTailwind, components);
